import { genericUpsellOptionsDefault } from '@basket/types/BasketUpsellGenericContext';
import { createContext } from 'preact/compat';
import { optionsDefaults as bookingFormOptionsDefaults, } from '@bookingForm/context/Options';
export const optionsDefaults = {
    ...genericUpsellOptionsDefault,
    type: 'combo-form',
    item: {},
    bookingForm: bookingFormOptionsDefaults,
    formTitle: undefined,
    buttonText: 'Add to Booking',
};
export const BasketUpsellComboFormCTX = createContext(optionsDefaults);
